<template>
  <div class="map-wrapper">
    <div class="res-content-wrapper">
      <ion-grid class="loc-search">
        <ion-row>
          <ion-col size-md="11" size-xs="12">
            <div class="loc-wrpaper">
              <span class="rp-desktop">Location:</span>
              <span class="rp-mobile"><img src="/assets/images/common/search/116836@2x.png" class="lense-icon"/></span>
              <input type="text" id="pac-input" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" v-model="searchText" @click="clearInputs"  @input="searchPlaces" placeholder="Enter Location" />
              <img src="../../assets/locate.svg" class="map-marker-icon" v-on:click="config">
            </div>
             <div
                v-if="predictions.length"
                class="suggestions"
              >
                <div
                  v-for="place in predictions"
                  :key="place.place_id"
                  class="suggestion-item"
                  @click="selectPlace(place)"
                >
                   <!-- Location Icon -->
                   <img
                      src="/assets/images/station/117967-1.png"
                      class="location-icon"
                      alt="location"
                    />


                  <!-- Place Name -->
                  <span class="place-text">
                    {{ place.description }}
                  </span>
                </div>
              </div>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>

    <div ref="mapRef" class="google-map"></div>

    <div class="card-list-wrapper" v-if="chargeNow">
      <div>
          <ion-grid>
              <ion-row>
                  <ion-col>
                      <div class="qrcodeStream">
                        <qrcode-stream  v-if="isShowingCamera" @detect="onDetect"/>
                      </div> 
                  </ion-col>
              </ion-row>
          </ion-grid>
        </div>
    </div>
    <div v-if="!isShowingCamera"  class="rp-mobile">
      <ion-fab horizontal="center">
        <ion-fab-button  @click="openScannerForTagId()" class="chargeNowFab">
          <div class="scanner-wrapper">
            <img src="/assets/images/reservation/qr_code.svg" class="qr-svg" >
            <span class="scan-line"></span>
          </div>
        </ion-fab-button>
      </ion-fab>
    </div>
    
    <div v-if="isShowingCamera"  class="rp-mobile">
      <ion-fab horizontal="center" size="large">
        <ion-fab-button  @click="closeScanner()" class="chargeNowFab"> Cancel</ion-fab-button>
      </ion-fab>
    </div>
    <div class="card-list-wrapper">
      <div class="card-list" v-if="cardType === true">
        <ion-grid>
          <ion-row>
            <ion-col size-md="6" size-xs="12">
              <div class="card-list-content">
                <p class="ion-no-margin title">{{selectedLocation.name}}<span v-if="selectedLocation.rating != 0">&nbsp;{{selectedLocation.rating}} &nbsp;<ion-icon class="star-rating" :icon="star"></ion-icon></span></p>
                <p class="ion-no-margin loc">{{selectedLocation.address.line1}},
                  {{selectedLocation.address.city}}</p>
                <p class="ion-no-margin time">Open : {{opensAt}} - {{closesAt}}</p>
              </div>
            </ion-col>
            <ion-col size-md="6" size-xs="12">
              <div class="card-list-booking">
                <p class="ion-no-margin">{{selectedMarkerDistance}}</p>
                <div class="call-options">
                    <a v-bind:href="teleUrl" class="call-img-a">
                      <img class="call-img" src="../../assets/card-call.png" />
                    </a>
                    <img @click="googleMapApp()" class="map-img" src="../../assets/card-map.png" />
                    <ion-button class="book-btn" v-if="stationMarkerStatus == 'deactivedstation'"
                      disabled @click="bookNow()" expand="block" shape="round">Next</ion-button>
                    <ion-button class="book-btn" v-if="stationMarkerStatus != 'deactivedstation'"
                      @click="bookNow()" expand="block" shape="round">Next</ion-button>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>

    <div class="rp-mobile info-popup" v-if="showPopup">
      <span class="close-btn" @click="closePopup">×</span>
        <div class="popup-content">
          <div class="popup-text">
            <div class="scan-tag">
              <span>Scan QR</span>
            </div>
            <h3>Start Charging</h3>
            <p>Click the below Icon for Scaning the QR Code in the Charger</p>
          </div>
          <div class="popup-image">
            <div class="scanner-box">
              <div class="scanner-wrapper">
                  <img
                    class="qr-code-svg"
                    src="/assets/images/reservation/rapidEvCharge.jpeg"
                    alt="QR Code"
                  >
              </div>
              <div class="scanner-label">Bay - 2 / Port - 2</div>
            </div>
          </div>
        </div>
    </div>
    <div class="rp-mobile">
      <ion-fab vertical="bottom" horizontal="start">
        <ion-fab-button  @click="refreshMap()" class="mapRefresh" size="small">
          <ion-icon :icon="refresh"  class="refresh-icon"></ion-icon>
        </ion-fab-button>
      </ion-fab>
    </div>
    <div>
      <ion-grid>
        <ion-row>
          <ion-col>
            <ion-loading :is-open="isLoading" class="custom-loading" spinner="lines-sharp" message="Please Wait..." v-if="isLoading"></ion-loading>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { EVCStationService } from "@/service/evcstation/stations.service";
import { setOptions, importLibrary, } from "@googlemaps/js-api-loader";
import {MarkerClusterer, SuperClusterAlgorithm, } from "@googlemaps/markerclusterer";
import { IonGrid, IonRow, IonCol, IonFab, IonFabButton, IonSpinner, IonButton, IonIcon, IonLoading } from "@ionic/vue";
import { QrcodeStream } from "vue-qrcode-reader";
import { Coordiate } from '@/entity/location/corodinate';
import { LocalStorage } from "../../data/localstorage";
import { ConfigurationService } from "../../service/configuration";
import { ToastUtils } from "../../util/toast-utils";
import { trash, star,download, homeSharp, refresh } from 'ionicons/icons';
import { EVChargerType } from '@/entity/station/evcharger';
import { RecentlySelectedFilterCriteria } from '@/entity/station/reservation';
import { Geolocation } from '@capacitor/geolocation';


export default defineComponent({
  name: "GoogleMapWithCluster",
  components: {
    IonGrid, 
    IonRow, 
    IonCol, 
    IonFab, 
    IonFabButton, 
    IonSpinner, 
    IonButton,
    IonIcon,
    QrcodeStream,
    IonLoading
  },
  data() {
    return {
      isLoading: false,
      refresh,
      trash, 
      star,
      download, 
      homeSharp,
      map: null,
      locations: [],
      locationAdd: "",
      searchText: "",
      predictions: [],
      autocompleteService: null,
      placesService: null,
      cardType: false,
      teleUrl: "",
      selectedMarkerDistance: "",
      stationMarkerStatus: false,
      opensAt: "",
      closesAt: "",
      selectedMarker: null,
      selectedLocation: null,
      chargeNow: false,
      isShowingCamera: false,
      showPopup: true,
      chargerTypesSelectedValue: "",
      chargerOutputSelectedValue: "",
      chargerPortSelectedValue: "",
      currentLoc: {
        latitude: "",
        longitude: ""
      },
      markerCluster: null
    };
  },

  created() {
    this.clickMarker = null;
  },

  async mounted() {
    await this.initiateMap();
  },

  methods: {
    closePopup() {
      this.showPopup = false;
    },
    bookNow() {
        this.loaderTab = true;
        localStorage.setItem("teleUrl", this.teleUrl)
        localStorage.setItem("selectedMarker", JSON.stringify(this.selectedLocation))
        localStorage.setItem("opensAt", this.opensAt)
        localStorage.setItem("closesAt", this.closesAt)
        this.loaderTab = false;
        this.$router.push({ name: "bookNow" });
    },
    async initiateMap() {
      try {
        this.isLoading = true;
        setOptions({
          apiKey: "AIzaSyBCU1EjZJ8ZRmWpYxaK55nAKKcehh-cTwM",
          version: "weekly",
        });

        // Import libraries
        const { Map } = await importLibrary("maps");
        const { Marker } = await importLibrary("marker");
        const { Size } = await importLibrary("core");
        const { AutocompleteService, PlacesService  } = await importLibrary("places");
       
       let center;
        try {
          const coordinates = await Geolocation.getCurrentPosition({
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 300000
          });
          center = {
            lat: coordinates.coords.latitude,
            lng: coordinates.coords.longitude,
          };

          this.currentLoc = {
            latitude: coordinates.coords.latitude,
            longitude: coordinates.coords.longitude,
            type: 'current'
          };
          localStorage.setItem("currentLoc", JSON.stringify(this.currentLoc));
        } catch (error) {
          this.isLoading = false;
          console.error("Location error:", error);
          let message = 'Unable to fetch location';

          if (error.code === 1) {
            message = 'Location permission denied';
          } else if (error.code === 2) {
            message = 'Location unavailable';
          } else if (error.code === 3) {
            message = 'Location request timeout';
          }

          new ToastUtils().presentToast(message);

          // Fallback location
          center = {
            lat: 11.0487119985167,
            lng: 77.048380874338,
          };
        }
        var myStyles =[
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [
              { visibility: "off" }
            ]
          }
        ];
        // Create map
        this.map = new Map(this.$refs.mapRef, {
          center,
          styles: myStyles,
          zoom: 15,
          draggable: true,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
        });
        this.clickMarker = new Marker({
          map: this.map,
          position: center,
          icon: {
            url:
              "/assets/images/reservation/75689@2x.png",

            scaledSize: new Size(20, 20),
          },
          title: "Current Location",
          zIndex: 9999,
        });
        this.getSelectedLocationName(center.lat, center.lng);
         // Autocomplete
        this.autocompleteService =
          new AutocompleteService();
        this.placesService =
          new PlacesService(this.map);
        await this.getStations()
        // Map click
        this.map.addListener("click", (event) => {
          const lat = event.latLng.lat();
          const lng = event.latLng.lng();
          this.currentLoc.latitude = lat;
          this.currentLoc.longitude = lng;
          localStorage.setItem("currentLoc", JSON.stringify(this.currentLoc));
          this.predictions = [];
          // Remove old marker
          if (this.clickMarker) {
            this.clickMarker.setMap(null);
          }

          // Add new marker
          this.clickMarker = new Marker({
            map: this.map,
            position: { lat, lng },
            icon: {
              url: "/assets/images/reservation/75689@2x.png",
              scaledSize: new Size(20, 20),
            },
          });
        //Get location name
        this.getSelectedLocationName(lat, lng);
        this.getStations()

        });
      } catch (error) {
        console.error("Google Maps failed to load", error);
        this.isLoading = false;
      }
    },
    getSelectedLocationName(lat, lng) {
       // GET LOCATION NAME
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({location: { lat, lng },},(results, status) => {

        if (status === "OK" && results[0]) {
          // FULL ADDRESS
          this.searchText = results[0].formatted_address;
          this.searchText = results[0].formatted_address
          localStorage.setItem("Autocomplete",results[0].formatted_address);
        } else {
          console.log("Geocoder failed:", status);
        }
      });
    },
    clearInputs() {
      document.getElementById("pac-input").value = "";
      this.locationAdd = "";
      this.locationAdd = null;
    },
    async searchPlaces() {
      if (!this.searchText || this.searchText.trim() === "") {
        this.predictions = [];
        return;
      }

      this.autocompleteService.getPlacePredictions(
        {
          input: this.searchText,
          // componentRestrictions: {
          //   country: "in",
          // },
        },
        (predictions, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            this.predictions = predictions;
          } else {
            this.predictions = [];
          }
        }
      );
    },
    selectPlace(place) {
      this.searchText = place.description;
      this.predictions = [];

      this.placesService.getDetails(
        {
          placeId: place.place_id,
        },
        (result, status) => {

          if (status === google.maps.places.PlacesServiceStatus.OK) {

            const location = result.geometry.location;

            const position = {
              lat: location.lat(),
              lng: location.lng(),
            };

            // Save selected location
            this.currentLoc = {
              latitude: position.lat,
              longitude: position.lng,
              type: 'current'
            };

            localStorage.setItem(
              "currentLoc",
              JSON.stringify(this.currentLoc)
            );

            // Update address text
            this.getSelectedLocationName(
              position.lat,
              position.lng
            );

            // Move map
            this.map.panTo(position);
            this.map.setZoom(15);

            // Remove old marker
            if (this.clickMarker) {
              this.clickMarker.setMap(null);
            }

            // Add marker
            this.clickMarker = new google.maps.Marker({
              map: this.map,
              position,
              icon: {
                url: "/assets/images/reservation/75689@2x.png",
                scaledSize: new google.maps.Size(20, 20),
              },
            });

            // Reload nearby stations for selected place
            this.getStations();
          }
        }
      );
    },
    async config() {
      this.isLoading = true;
      await new ConfigurationService().configuration().then((data) => {
          this.configData = data;
          this.initiateMap();
          this.isLoading = false;
      }).catch((error) => {
          this.isLoading = false;
          let serviceError = migratedTryParseServiceError(error);
          new ToastUtils().presentToast(serviceError.description);
      });
    },
    async refreshMap() {
      this.isLoading = true;
      this.cardType = false;
      this.showPopup = true;
      this.predictions = [];
      this.clearInputs();
      await this.initiateMap();
      this.isLoading = false;
    },
    async getStations() {
      try {
        let loadFilterdata = JSON.parse(localStorage.getItem('userFilterData'));
        if(loadFilterdata != null) {
          this.isLoading = true;
          let filterCriteria = new RecentlySelectedFilterCriteria(
            new EVChargerType(loadFilterdata.chargerTypeGroup.code),                       
            {id: ""},
            {id: ""}
          )
          this.chargerTypesSelectedValue = filterCriteria.chargerType
          this.chargerOutputSelectedValue = filterCriteria.outputType
          this.chargerPortSelectedValue = filterCriteria.portType
        }
        const response = await new EVCStationService().stationsAroundLocationForUser(
          new Coordiate(this.currentLoc.latitude, this.currentLoc.longitude),
          new LocalStorage().user,
          {
            chargerType: this.chargerTypesSelectedValue,
            outputType: this.chargerOutputSelectedValue,
            portType: this.chargerPortSelectedValue,
            radius: 50,
            viewType: "MAP",
          }
        );
        this.locations = response;
        localStorage.removeItem('userFilterData')
        this.chargerTypesSelectedValue= "",
        this.chargerOutputSelectedValue= "",
        this.chargerPortSelectedValue= "",
        this.renderMarker();
        this.isLoading = false;
      } catch(error) {
        this.isLoading = false;
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
      
    },

    async renderMarker() {
      const { Marker } = await importLibrary("marker");
      const { Size } = await importLibrary("core");

      if (this.markerCluster) {
        this.markerCluster.clearMarkers();
        this.markerCluster = null;
      }
      // Create markers
      const markers = this.locations.map((location) => {

        const lat = Number(location.coordinate.latitude);
        const lng = Number(location.coordinate.longitude);

        // Default icon
        let iconUrl = "/assets/images/reservation/159615_av.png";

        if(location.status.id == 'A') {
            // CAP
          if (location.stationCategory?.id === "CAP") {
            iconUrl = "/assets/images/reservation/159615_unrh.png";
          }
          // CPO
          if (location.stationCategory?.id === "CPO") {
            iconUrl = "/assets/images/reservation/159615.png";
          }
          // THRDPRT
          if (location.stationCategory?.id === "THRDPRT") {
            iconUrl = "/assets/images/reservation/159615_01.png";
          }
        } else {
          iconUrl = "/assets/images/reservation/159615-1.png";
        }
        // Create marker
        const marker = new Marker({
          position: { lat, lng },

          title: location.stationName,

          icon: {
            url: iconUrl,

            scaledSize: new Size(34, 38),
          },
        });
        
        marker.addListener("click", () => {

          const previousMarker = this.selectedMarker;
          const previousLocation = this.selectedLocation;

          // RESET PREVIOUS MARKER ICON
          if (previousMarker && previousLocation) {

            let previousIcon = "";

            if (previousLocation.status.id == "A") {

              if (previousLocation.stationCategory?.id === "CAP") {
                previousIcon = "/assets/images/reservation/159615_unrh.png";
              }

              if (previousLocation.stationCategory?.id === "CPO") {
                previousIcon = "/assets/images/reservation/159615.png";
              }

              if (previousLocation.stationCategory?.id === "THRDPRT") {
                previousIcon = "/assets/images/reservation/159615_01.png";
              }

            } else {
              previousIcon = "/assets/images/reservation/159615-1.png";
            }

            previousMarker.setIcon({
              url: previousIcon,
              scaledSize: new Size(38, 40),
            });
          }

          // CURRENT SELECTED ICON
          let currentUrl = "";

          if (location.status.id == "A") {

            if (location.stationCategory?.id === "CAP") {
              currentUrl = "/assets/images/reservation/mark_unrh.png";
            }

            if (location.stationCategory?.id === "CPO") {
              currentUrl = "/assets/images/reservation/mark.png";
            }

            if (location.stationCategory?.id === "THRDPRT") {
              currentUrl = "/assets/images/reservation/ThirdPartymark.png";
            }

          } else {
            currentUrl = "/assets/images/reservation/mark_unav.png";
          }

          // SET CURRENT SELECTED ICON
          marker.setIcon({
            url: currentUrl,
            scaledSize: new Size(38, 42),
          });

          // SAVE CURRENT REFERENCES
          this.selectedMarker = marker;
          this.selectedLocation = location;

          // CARD DETAILS
          var hoursOfOperations = this.selectedLocation.hoursOfOperations;
          this.selectedMarkerDistance = this.selectedLocation.distance.description;

          var d = new Date();
          var n = d.getDay();

          if (d.getDay() == 0) {
            n = 6;
          } else if (d.getDay() == 1) {
            n = 0;
          } else {
            n = n - 1;
          }

          var selectedDate = hoursOfOperations[n];

          this.opensAt = selectedDate.opensAt;
          this.closesAt = selectedDate.closesAt;
          this.showPopup = false;
          this.cardType = true;

          this.teleUrl = "tel:" + this.selectedLocation.mobile;

          this.stationMarkerStatus = marker.iconType;
        });
        return marker;
      });

      // Cluster
      this.markerCluster = new MarkerClusterer({
        map: this.map,
        markers,

        algorithm: new SuperClusterAlgorithm({
          radius: 80,
        }),
        onClusterClick: (event, cluster, map) => {
          // Center on cluster
          map.panTo(cluster.position);

          // Increase zoom by only 1 level
          map.setZoom(Math.min(map.getZoom() + 1, 18));

          // Prevent default zoom-to-bounds behavior
          return false;
        },
        renderer: {
            render({ count, position }) {

              return new Marker({
                position,

                label: {
                  text: String(count),
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "bold",
                },

                icon: {
                  path: google.maps.SymbolPath.CIRCLE,

                  fillColor: "#21b24b", // cluster color
                  fillOpacity: 1,

                  strokeColor: "#2dd55b",
                  strokeWeight: 1,

                  scale: 18,
                },

                zIndex: 1000 + count,
              });
            },
        }
      });
    },
    async openScannerForTagId() {
      try {
        this.showPopup = false;
        this.chargeNow = true;
        this.isShowingCamera = true;
      } catch(error) {
        this.chargeNow = false;
        this.isShowingCamera = false;
      }
    },
    closeScanner() {
      this.chargeNow = false;
      this.isShowingCamera = false;
    },
    async onDetect (result) {
      try {
        let stationInfoByQRCode = await new EVCStationService().getStationInfoByQRCodeValue(result[0].rawValue)
        if (stationInfoByQRCode.stationId) {
          try {
            let stationInfo = await new EVCStationService().stationWithId(stationInfoByQRCode.stationId);
            var d = new Date();
            var n = d.getDay()
            if (d.getDay() == 0) {
                n = 6;
            } else if (d.getDay() == 1) {
                n = 0;
            } else {
                n = n - 1
            }
            localStorage.setItem("teleUrl", stationInfo.mobile);
            localStorage.setItem("selectedMarker", JSON.stringify(stationInfo));
            localStorage.setItem("opensAt", stationInfo.hoursOfOperations[n].opensAt);
            localStorage.setItem("closesAt", stationInfo.hoursOfOperations[n].closesAt);
            localStorage.setItem('chargeNow', true);
            localStorage.setItem('portId', stationInfoByQRCode.portId);
            localStorage.setItem('outputNumber', stationInfoByQRCode.outputNumber)
            localStorage.setItem("qrCodeValue", result[0].rawValue)
            this.$router.push({ name: "bookNow" });
          } catch(error) {
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
          }
        } else {
          this.chargeNow = false;
          this.isShowingCamera = false;
          new ToastUtils().presentToast("Invalid QR code");
        }
      } catch(error) {
        let serviceError = migratedTryParseServiceError(error);
        new ToastUtils().presentToast(serviceError.description);
      }
    },
  }
});
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 100vh;
   touch-action: pan-x pan-y;
}
.info-popup {
    position: fixed;
    bottom: 125px;
    left: 50%;
    transform: translateX(-50%);
    width: 320px;
    padding: 24px;
    background: #1e293b;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.25);
    z-index: 999;
}

.info-popup::after { 
    content: ""; 
    position: absolute; 
    bottom: -10px; 
    left: 50%; 
    transform: translateX(-50%) rotate(45deg); 
    width: 20px; 
    height: 20px; 
    background: #1e293b; 
    box-shadow: 2px 2px 5px rgba(0,0,0,0.1); 
}

.popup-content {
    display: flex;
    align-items: center;
    gap: 14px;
}

.popup-text {
    flex: 1;
}

.scan-tag {
    display: inline-flex;
    align-items: center;
    background: rgba(34,197,94,0.15);
    color: #4ade80;
    padding: 4px 6px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 10px;
}

.popup-text h3 {
    color: #fff;
    font-size: 18px;
    margin: 0 0 6px;
}

.popup-text p {
    color: #cbd5e1;
    font-size: 13px;
    line-height: 1.5;
    margin: 0;
}

.scanner-box {
    margin-top: 12px;
    background: #fff;
    border-radius: 14px;
    padding: 10px;
    width: 100px;
    text-align: center;
}

.qr-code-svg {
    width: 55px;
    height: 55px;
}

.scanner-label {
    margin-top: 6px;
    font-size: 10px;
    color: #444;
    font-weight: 600;
}

.close-btn {
    position: absolute;
    top: 6px;
    right: 15px;

    color: #fff;
    font-size: 22px;
    cursor: pointer;
}

.scanner-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.qr-svg { width: 55px; height: 55px; filter: brightness(0) invert(0.95); position: relative; z-index: 2; }

.scan-line {
    position: absolute;
    width: 28px;
    height: 2px;

    background: #00ff99;
    border-radius: 10px;

    animation: scanMove 2s linear infinite;
}

@keyframes scanMove {
    0% {
        top: 12px;
    }
    50% {
        top: 40px;
    }
    100% {
        top: 12px;
    }
}

ion-fab-button {
  padding-bottom: 50px;
}
#loader {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: sans-serif;
  font-size: 22px;
  color: #21b24b;
  /* font-weight: bold; */
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

.qrcodeStream {
width: 50%;
height: 30%;
margin: 0 auto;
border: 5px solid #21b24b;
/* border-right: 5px solid #21b24b; */
border-radius: 5px;
margin-bottom: 90%;
} 

.mapRefresh {
    width: 43px;
    height: 92px;
    --background: rgb(255, 255, 255); 
    /* margin-top: 0px; */
    /* opacity: 0.9; */
    
}
.refresh-icon {
    color: rgb(106, 103, 103);
    font-size: 1.6rem;
    /* font-weight: bold; */
}
.qr-svg {
    width: 30px;
    color: rgb(250, 249, 249);
    /* font-weight: bolder; */
}
#pac-input:focus,
.res-content-wrapper .loc-search input:focus{
    padding: 12px;
    margin: 0;
}
    #res-map {
        height: 94%;
        width: 100%;
    }
.map-overlay{
    background: #000000;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    opacity: 0.3;
}
.spinnerWrapper{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%)
}
/* .map-wrapper {
    height: 100%;
    width: 100%;
} */

.card-list-wrapper {
    position: absolute;
}

.res-content-wrapper {
  position: fixed;
  top: calc(env(safe-area-inset-top) + 60px);
  width: 100%;
  z-index: 1000;
  padding: 16px;
}

.card-list-content p.title {
    text-align: left;
    font-size: 16px;
    font-family: 'Roboto Medium';
    letter-spacing: 0;
    color: #313131;
    opacity: 1;
    margin-bottom: 8px;
}

.card-list-content p.time {
    font-family: 'Roboto Light';
}

.card-list-content p.loc,
.card-list-content p.time {
    text-align: left;
    margin-bottom: 8px;
    font-size: 15px;
    letter-spacing: 0;
    color: #313131;
    opacity: 0.75;
}

.card-list-booking p {
    height: 17px;
    text-align: right;
    margin-right: 8px;
    font-size: 14px;
    font-family: 'Roboto';
    letter-spacing: 0;
    color: #D66C6C;
    opacity: 1;
}

.card-list-booking {
    text-align: right;
}
.iocl-div-img {
    text-align: right;
}
.iocl_img {
    margin-top: -1rem;
    width: 300px;
    /* height: 15%; */
}
.call-options .book-btn {
    width: 115px;
    --background: #21b24b !important;
    border-radius: 36px;
    /* opacity: 1; */
    text-align: left;
    font-size: 16px;
    font-family: 'Roboto Medium';
    letter-spacing: 0;
    color: #FFFFFF;
    display: inline-block;
    position: relative;
    top: -15px;
}

.call-options {
    margin-top: 16px;
}

.call-options img.call-img {
    width: 24px;
    height: 24px;
    position: relative;
    top: -3px;
}

.call-options a.call-img-a {
    margin-right: 21px;
}

.call-options img.map-img {
    width: 36px;
    height: 36px;
    margin-right: 29px;
    cursor: pointer;
}

.card-list-content p.loc {
    font-family: 'Roboto';
}

.card-list-wrapper {
    bottom: 100px;
    width: 100%;
    padding: 0 30px;

}

@media (max-width: 768px) {
    .card-list-wrapper {
        padding: 0 14px;
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }
}

.card-list {
    height: 131px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 16px;
    opacity: 1;
    padding: 16px;
}

@media (max-width: 768px) {
    .card-list {
        height: 185px;
    }

    .card-list-booking {
        text-align: left !important;
        position: absolute;
        width: 100%;
        top: -36px;
    }

    .call-options .book-btn {
        position: absolute;
        top: 27px;
        right: 0px;
    }

    .card-list-booking p {
        position: relative;
        top: 6px;
    }

    .res-content-wrapper {
        padding: 0px !important;
    }
}

/* SearchBox */

.res-content-wrapper.listView .loc-search {
    padding-top: 15px;
    padding-bottom: 15px;
    border-bottom: 1px solid #D6D6D6;
    background: #F4F5F9;
}

.res-content-wrapper.listView {
    background: #F4F5F9;
}

.res-content-wrapper .loc-search input {
    height: 52px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #0000001A;
    border-radius: 12px;
    opacity: 1;
    width: 100%;
    padding: 12px;
    padding-left: 98px !important;
    font-size: 14px;
    text-align: left;
    padding-left: 24px;
    font-family: 'Roboto';
    letter-spacing: 0;
    color: #9e9d9d;
}

.res-content-wrapper .loc-search img.map-marker-icon {
    width: 18px;
    height: 18px;
    opacity: 1;
    cursor: pointer;
}

.loc-wrpaper span {
    height: 17px;
    text-align: left;
    font-size: 14px;
    position: absolute;
    font-family: 'Roboto';
    letter-spacing: 0;
    top: 18px;
    padding-left: 18px;
    color: #404040;
    opacity: 1;

}

.loc-wrpaper img,
.loc-wrpaper span {
    z-index: 99;
}

.loc-wrpaper {
    position: relative;
}

.loc-wrpaper img.map-marker-icon {
    position: absolute;
    right: 12px;
    top: 17px;
    cursor: pointer;
}

@media (max-width: 768px) {
    .lense-icon{
        position: absolute;
    }
    .res-content-wrapper .loc-search input {
        padding-left: 50px !important;
        text-overflow: ellipsis;
        padding-right: 56px;
    }

    .res-content-wrapper .loc-search {
        padding: 9px;
    }
}

/* Autocompletion css start */
.map-container {
  position: relative;
}

.search-box {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 999;
  width: 320px;
}

.search-box input {
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.suggestions {
  background: white;
  border-radius: 6px;
  margin-top: 4px;
  max-height: 250px;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
}

.suggestion-item {
  padding: 10px;
  cursor: pointer;
}

.suggestion-item:hover {
  background: #f3f3f3;
}

.google-map {
  width: 100%;
  height: 100vh;
}
.suggestions {
  background: white;
  border-radius: 8px;
  margin-top: 6px;
  max-height: 260px;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  border: 1px solid #e5e5e5;
}

.suggestion-item {
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 12px;
  cursor: pointer;

  border-bottom: 1px solid #eaeaea;

  transition: background 0.2s ease;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-item:hover {
  background: #f7f7f7;
}

.location-icon {
  font-size: 16px;
  color: #cb1a27;
}

.place-text {
  font-size: 14px;
  color: #333;
}
.suggestion-item {
  display: flex;
  align-items: center;
  gap: 10px;

  padding: 12px;
  cursor: pointer;

  border-bottom: 1px solid #eaeaea;

  transition: background 0.2s ease;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-item:hover {
  background: #f7f7f7;
}

.location-icon {
  width: 16px;
  height: 15px;
  object-fit: contain;
  flex-shrink: 0;
}

.place-text {
  font-size: 12px;
  color: #333;
}

/* Autocompletion css end */

</style>